const de = {
  // Navbar
  "nav.visione": "Die Vision",
  "nav.territorio": "Das Gebiet",
  "nav.servizi": "Leistungen",
  "nav.immobili": "Immobilien",
  "nav.contatti": "Kontakt",
  "nav.progetto": "Das Projekt",

  // Hero
  "hero.tagline": "Jedes Dorf hat eine Geschichte zu bewahren.\nJedes Haus kann der Beginn eines neuen Lebens sein.",
  "hero.cta": "Immobilien entdecken",
  "hero.scroll": "Scrollen",

  // Visione
  "visione.overline": "MEINE Vision",
  "visione.title": "Wir erzählen Geschichten von Landschaften.",
  "visione.text": "Die Marken bewahren ein außergewöhnliches, stilles Erbe: mittelalterliche Dörfer, in denen die Zeit langsam vergeht, sonnenüberflutete Steinplätze, enge Gassen, die Jahrhunderte der Geschichte atmen. Zwischen der Adria und den Sibyllinischen Bergen bewahren diese goldenen Hügel eine Lebensqualität, die die moderne Welt vergessen hat. Wir verkaufen keine Immobilien. Wir öffnen Türen zu Landschaften, die entdeckt werden wollen, zu Rhythmen, die wiedergefunden werden sollen, zu Wurzeln, die noch gebaut werden können.",
  "visione.ines.name": "Ines Felicity Di Nallo",
  "visione.ines.role": "Zugelassene Immobilienmaklerin",
  "visione.ines.bio": "Zulassung CCIAA Ancona (Oktober 2025) — Abschluss in Wirtschaftswissenschaften, Universität Bologna — Ehemalige Leiterin Meeting & Events, G Hotel Ancona — Expertin für digitales Marketing und internationale Beziehungen. Dreisprachig: Italienisch, Englisch und Spanisch.",
  "visione.ines.badge.license": "CCIAA Ancona",
  "visione.ines.badge.unibo": "Wirtschaftsabschluss",
  "visione.ines.badge.languages": "IT · EN · ES",

  // Territorio
  "territorio.overline": "Das Gebiet",
  "territorio.title": "Die Marken: wo die Zeit langsamer\nwird und Schönheit zu Hause ist",
  "territorio.text": "Eine Region, die Meer, Berge und Hügel auf wenigen Kilometern vereint. Die Riviera del Conero mit ihrem kristallklaren Wasser, mittelalterliche Dörfer wie Castelfidardo als Hüter von Handwerk und Musik, mit Reben und Olivenbäumen bepflanzte Hügel, eine Küche, die Jahrhunderte bäuerlicher Weisheit erzählt. Die Marken sind ein gut gehütetes Geheimnis — der Ort, wo wer nach echter Schönheit sucht, eine Heimat findet.",
  "territorio.caption1": "Historische Treppe - Corinaldo",
  "territorio.caption2": "Riviera del Conero",
  "territorio.caption3": "Rocca Roveresca - Mondavio",
  "territorio.caption4": "Marchigianische Hügel",
  "territorio.keyword1": "Meer",
  "territorio.keyword2": "historische Dörfer",
  "territorio.keyword3": "Kulinarik & Wein",

  // Servizi
  "servizi.overline": "Was wir tun",
  "servizi.0.title": "Wir erzählen die Geschichte des Landes",
  "servizi.0.desc": "Historische Dörfer, landwirtschaftliche Betriebe und lokale Beherbergungsbetriebe sind nicht nur Immobilien — sie sind Geschichten, die es wert sind, bewahrt und erzählt zu werden. Wir gestalten authentische Narrative für jeden Ort, heben seine Identität, Geschichte und sein Potenzial hervor, um Menschen anzuziehen, die nicht nur ein Haus, sondern eine Lebensweise suchen.",
  "servizi.0.step1": "Zuhören der Geschichte und Identität jedes Ortes",
  "servizi.0.step2": "Präsentation von Dörfern, Bauernhöfen und Landgütern",
  "servizi.0.step3": "Authentisches Storytelling für lokale Beherbergungsbetriebe",
  "servizi.0.step4": "Marktpositionierung durch eine herausragende Erzählung",
  "servizi.title": "Ein maßgeschneiderter Service,\nkeine Preisliste.",
  "servizi.1.title": "Verkauf historischer Dörfer",
  "servizi.1.desc": "Sorgfältige Auswahl von Immobilien in historischen Dörfern der Marken: Bauernhäuser, Landsitze, Adelspaläste, Häuser mit echtem Charakter und Seele.",
  "servizi.2.title": "Internationaler Beistand",
  "servizi.2.desc": "Vollständige Beratung auf Italienisch, Englisch und Spanisch für internationale Käufer. Von der Suche bis zur Unterschrift — jeder Schritt in Ihrer Sprache begleitet.",
  "servizi.3.title": "Fotografie & Virtuelle Touren",
  "servizi.3.desc": "Professionelle Fotoreportagen und 360°-Touren, um jede Immobilie mit der visuellen Qualität zu präsentieren, die sie verdient.",
  "servizi.4.title": "Expertennetzwerk",
  "servizi.4.desc": "Zugang zu einem ausgewählten Netzwerk von Architekten, Innenarchitekten, Vermessern, Notaren und Rechtsspezialisten für Immobilientransaktionen.",

  // Immobili
  "immobili.overline": "Ausgewählt",
  "immobili.title": "Ausgewählte Immobilien",
  "immobili.cta": "Informationen anfordern",
  "immobili.badge1": "Castelfidardo",
  "immobili.badge2": "Riviera del Conero",
  "immobili.badge3": "Hügel von Osimo",
  "immobili.prop1.title": "Restauriertes Bauernhaus",
  "immobili.prop1.type": "Landhaus · 240 m² · Hügelblick",
  "immobili.prop2.title": "Historische Residenz im Dorf",
  "immobili.prop2.type": "Historischer Palazzo · 380 m² · Altstadt",
  "immobili.prop3.title": "Panoramavilla am Conero",
  "immobili.prop3.type": "Villa · 320 m² · Meerblick",

  // Per Chi
  "perchi.overline": "Für wen ist das",
  "perchi.title": "Jede Geschichte verdient\nihr eigenes Territorium.",
  "perchi.1.title": "Familien & Junge Berufstätige",
  "perchi.1.desc": "Wer eine echte Lebensqualität sucht, Raum zum Wachsen, Dörfer, in denen menschliche Rhythmen noch möglich sind und Schönheit alltäglich ist.",
  "perchi.2.title": "Internationale Käufer",
  "perchi.2.desc": "Europäer, Angelsachsen, Lateinamerikaner, die vom echten Italien fasziniert sind: vollständige Begleitung von der Suche bis zur Schlüsselübergabe, in Ihrer Sprache.",
  "perchi.3.title": "Immobilieninvestoren",
  "perchi.3.desc": "Wer auf hochwertige Immobilien, Agritourismen, Beherbergungsbetriebe in einer Region mit außergewöhnlichem und noch weitgehend ungenutztem Touristenpotenzial setzt.",

  // Contatti
  "contatti.overline": "Sprechen wir",
  "contatti.title": "Jede große Geschichte beginnt\nmit einem Gespräch.",
  "contatti.name": "Name",
  "contatti.email": "E-Mail",
  "contatti.phone": "Telefon",
  "contatti.message": "Nachricht",
  "contatti.message.placeholder": "Erzählen Sie uns, was Sie suchen...",
  "contatti.submit": "Nachricht senden",
  "contatti.success": "Nachricht gesendet! Wir melden uns bald.",
  "contatti.error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "contatti.sede": "Castelfidardo (AN), Italien",
  "contatti.lingue": "Italiano · English · Español",
  "contatti.instagram": "@felicity.dinallo_",

  // Footer FSE+
  "footer.copyright": "© 2026 Marche Casa. Alle Rechte vorbehalten.",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.progetto": "Das Projekt",
  "footer.fse.title": "Projekt mitfinanziert von der Europäischen Union",
  "footer.fse.text": "Projekt mitfinanziert von der Europäischen Union — PR FSE+ 2021/27 Regione Marche — DGR n. 977 del 24/06/2024",
  "footer.fse.logo1": "Coesione Italia 2021-2027",
  "footer.fse.logo2": "Mitfinanziert von der Europäischen Union",
  "footer.fse.logo3": "Italienische Republik",
  "footer.fse.logo4": "Regione Marche",

  // Nav new pages
  "nav.borghi": "Dörfer",
  "nav.blog": "Blog",

  // Footer new
  "footer.tagline": "Zugelassene Immobilienmaklerin CCIAA Ancona.\nHistorische Dörfer der Marken · IT · EN · ES",
  "footer.guida": "Kaufratgeber",

  // Borghi section (home)
  "borghi.cta": "Dorf entdecken",
  "borghi.viewAll": "Alle Dörfer ansehen",

  // Borghi page
  "borghi.overline": "Die Dörfer der Marken",
  "borghi.title": "Jedes Dorf ist eine Welt\ndie entdeckt werden will.",
  "borghi.intro": "Die Marken sind ein Archipel mittelalterlicher Dörfer, jedes mit seiner eigenen Identität, seiner eigenen Geschichte, seinem eigenen Charakter. Von der Conero-Küste bis zu den Hügeln des Hinterlandes bewahrt jedes Dorf ein einzigartiges Erbe.",
  "borghi.filter.tutti": "Alle",
  "borghi.filter.mare": "Meer",
  "borghi.filter.collina": "Hügel",
  "borghi.filter.entroterra": "Hinterland",
  "borghi.zona.mare": "Meer",
  "borghi.zona.collina": "Hügel",
  "borghi.zona.entroterra": "Hinterland",
  "borghi.scopri": "Dorf entdecken",
  "borghi.immobili.overline": "Ausgewählte Immobilien",
  "borghi.immobili.title": "Eine Immobilie für jedes Dorf.",
  "borghi.immobili.vedi": "Alle Immobilien ansehen",
  "borghi.cta.overline": "Suche beginnen",
  "borghi.cta.title": "Haben Sie ein Dorf im Sinn?",
  "borghi.cta.text": "Erzählen Sie uns, wo Sie leben möchten, und wir helfen Ihnen, das richtige Haus zu finden.",
  "borghi.cta.btn": "Kontakt aufnehmen",

  // Borgo detail
  "borgo.storia": "Geschichte & Identität",
  "borgo.storia.title": "{{name}} entdecken",
  "borgo.immobili.overline": "Immobilien in diesem Dorf",
  "borgo.immobili.title": "Immobilien in {{name}}",
  "borgo.cta.title": "Möchten Sie in {{name}} leben?",
  "borgo.cta.text": "Kontaktieren Sie uns, um Immobilienmöglichkeiten in diesem Dorf zu entdecken.",
  "borgo.cta.btn": "Informationen anfordern",

  // Immobili page
  "immobili.page.overline": "Immobilienkatalog",
  "immobili.page.title": "Ausgewählte Immobilien\nin den Marken-Dörfern.",
  "immobili.filter.tipologia": "Typ",
  "immobili.filter.target": "Für wen",
  "immobili.filter.borgo": "Dorf",
  "immobili.filter.tutti": "Alle",
  "immobili.filter.rustico": "Rustikal",
  "immobili.filter.palazzo": "Palazzo",
  "immobili.filter.villa": "Villa",
  "immobili.filter.casale": "Gehöft",
  "immobili.filter.prima-casa": "Erstwohnsitz",
  "immobili.filter.investimento": "Investition",
  "immobili.filter.turistico": "Tourismus",
  "immobili.risultati": "Immobilien gefunden",
  "immobili.locali": "Zimmer",
  "immobili.dettagli": "Details ansehen",
  "immobili.nessun": "Keine Immobilien mit den gewählten Filtern gefunden.",

  // Immobile detail
  "immobile.mq": "Fläche",
  "immobile.locali": "Zimmer",
  "immobile.piano": "Etage",
  "immobile.stato": "Zustand",
  "immobile.descrizione": "Beschreibung",
  "immobile.form.title": "Informationen anfordern",
  "immobile.form.subtitle": "Füllen Sie das Formular aus und wir antworten innerhalb von 24 Stunden.",
  "immobile.altri.title": "Weitere Immobilien in {{borgo}}",

  // Blog
  "blog.overline": "Geschichten & Einblicke",
  "blog.title": "Der Blog von\nMarche Casa.",
  "blog.filter.tutti": "Alle",
  "blog.leggi": "Artikel lesen",
  "blog.correlati": "Verwandte Artikel",
  "blog.borghi.correlati": "Verwandte Dörfer",
  "blog.sidebar.cta.title": "Suchen Sie ein Haus in den Marken?",
  "blog.sidebar.cta.text": "Wir helfen Ihnen, die perfekte Immobilie in Ihrem Traumdorf zu finden.",
  "blog.sidebar.cta.btn": "Kontakt aufnehmen",

  // Servizi page
  "servizi.page.title": "Ein maßgeschneiderter Service\nfür jede Geschichte.",
  "servizi.page.intro": "Wir sind keine traditionelle Agentur. Jeder Kunde ist eine einzigartige Geschichte, jede Immobilie ein Territorium, das erzählt werden will. Unser Ansatz ist persönlich, aufmerksam, dreisprachig.",
  "servizi.1.step1": "Analyse der Bedürfnisse und des Budgets",
  "servizi.1.step2": "Sorgfältige Immobilienauswahl",
  "servizi.1.step3": "Geführte Besichtigungen in den Dörfern",
  "servizi.1.step4": "Unterstützung bis zur Urkundenunterzeichnung",
  "servizi.2.step1": "Erstberatung in Ihrer Sprache",
  "servizi.2.step2": "Bürokratische Unterstützung (Steuernummer, Bankkonto)",
  "servizi.2.step3": "Koordination mit Notar und Rechtsanwalt",
  "servizi.2.step4": "Unterstützung nach dem Kauf",
  "servizi.3.step1": "Besichtigung und Planung des Fotoshootings",
  "servizi.3.step2": "Professionelles Shooting mit natürlichem Licht",
  "servizi.3.step3": "360°-Virtualtour mit immersiver Technologie",
  "servizi.3.step4": "Lieferung von für Web und Druck optimierten Materialien",
  "servizi.4.step1": "Bewertung der spezifischen Bedürfnisse",
  "servizi.4.step2": "Auswahl des geeignetsten Fachmanns",
  "servizi.4.step3": "Koordination und Überwachung",
  "servizi.4.step4": "Follow-up und Qualitätssicherung",
  "servizi.cta": "Diesen Service anfragen",
  "servizi.processo.overline": "Wie wir arbeiten",
  "servizi.processo.title": "Unser Prozess in 5 Schritten",
  "servizi.step1.title": "Zuhören",
  "servizi.step1.desc": "Ihre Bedürfnisse, Ihren Lebensstil und Ihr Budget verstehen",
  "servizi.step2.title": "Suche",
  "servizi.step2.desc": "Sorgfältige Auswahl der geeignetsten Immobilien",
  "servizi.step3.title": "Besichtigung",
  "servizi.step3.desc": "Geführte Touren in den Dörfern mit territorialen Einblicken",
  "servizi.step4.title": "Angebot",
  "servizi.step4.desc": "Unterstützung bei Verhandlung und Kaufangebot",
  "servizi.step5.title": "Urkunde",
  "servizi.step5.desc": "Vollständige Unterstützung bis zur Schlüsselübergabe",
  "servizi.cta.title": "Bereit anzufangen?",
  "servizi.cta.text": "Kontaktieren Sie uns für eine kostenlose, unverbindliche Beratung.",
  "servizi.cta.btn": "Beratung buchen",

  // Contatti page
  "contatti.page.title": "Jede große Geschichte beginnt\nmit einem Gespräch.",
  "contatti.info.overline": "Wo wir sind",
  "contatti.info.title": "Sprechen wir über Ihr\nLebensprojekt.",
  "contatti.info.text": "Ob Sie ein erstes Zuhause, eine Investition suchen oder Ihren Umzug in die Marken planen — wir sind hier, um Ihnen zuzuhören. Wir antworten auf Italienisch, Englisch und Spanisch.",
  "contatti.sede.label": "Standort",
  "contatti.lingue.label": "Sprachen",
  "contatti.abilitazione.label": "Zulassung",
  "contatti.borgo.label": "Dorf von Interesse",
  "contatti.borgo.placeholder": "Dorf auswählen...",
  "contatti.borgo.altro": "Anderes / Noch nicht sicher",
  "contatti.form.title": "Schreiben Sie uns",
  "contatti.form.subtitle": "Wir antworten innerhalb von 24 Stunden.",
  "contatti.success.title": "Nachricht gesendet!",

  // Move to Marche
  "move.hero.title": "Ihr neues Leben\nbeginnt hier.",
  "move.hero.subtitle": "Die Marken: authentische Lebensqualität, erschwingliche Preise, mittelalterliche Dörfer, Meer und Berge. Alles in einer Region.",
  "move.hero.cta": "Entdecken Sie, wie man umzieht",
  "move.why.overline": "Warum die Marken",
  "move.why.title": "Italiens authentischste\nRegion.",
  "move.why.text": "Die Marken bieten alles, was man in Italien sucht — Schönheit, Geschichte, Gastronomie, Meer — ohne die Menschenmassen und Preise der Toskana oder Umbriens.",
  "move.stat.costo": "Durchschnittliche monatliche Lebenshaltungskosten",
  "move.stat.costa": "Adriatische Küste",
  "move.stat.roma": "Von Rom mit dem Zug",
  "move.stat.aeroporti": "Nahe internationale Flughäfen",
  "move.process.overline": "Wie es funktioniert",
  "move.process.title": "Der Kaufprozess\nfür Nicht-Residenten.",
  "move.step1.title": "Steuernummer (Codice Fiscale)",
  "move.step1.desc": "Der erste Schritt ist die Beantragung einer italienischen Steuernummer, die für jede Transaktion erforderlich ist. Sie kann beim italienischen Konsulat in Ihrem Land oder direkt bei der Agenzia delle Entrate in Italien beantragt werden.",
  "move.step2.title": "Bankkonto",
  "move.step2.desc": "Die Eröffnung eines italienischen Bankkontos vereinfacht Zahlungen. Nicht obligatorisch, aber sehr empfehlenswert.",
  "move.step3.title": "Kaufangebot",
  "move.step3.desc": "Sobald Sie die Immobilie gefunden haben, unterzeichnen Sie ein Kaufangebot mit einer Anzahlung. Dies bindet beide Parteien an den Verkauf.",
  "move.step4.title": "Vorvertrag",
  "move.step4.desc": "Der Vorvertrag (compromesso) legt alle Bedingungen des Verkaufs fest. Eine zweite Anzahlung wird gezahlt, in der Regel 10-20% des Preises.",
  "move.step5.title": "Notarielle Urkunde",
  "move.step5.desc": "Die endgültige Kaufurkunde wird vor einem Notar unterzeichnet. Der Restbetrag wird gezahlt und die Schlüssel werden übergeben.",
  "move.faq.overline": "Häufig gestellte Fragen",
  "move.faq.title": "FAQ für ausländische Käufer",
  "move.faq.1.q": "Können Ausländer in Italien Immobilien kaufen?",
  "move.faq.1.a": "Ja, EU-Bürger können frei kaufen. Nicht-EU-Bürger können kaufen, wenn ein Gegenseitigkeitsabkommen zwischen Italien und ihrem Land besteht.",
  "move.faq.2.q": "Was kostet ein Haus in den Marken?",
  "move.faq.2.a": "Die Preise variieren stark: von €80.000 für ein zu renovierendes Rustico bis zu €700.000+ für Luxusvillen. Der Durchschnitt für eine bewohnbare Immobilie liegt zwischen €150.000 und €350.000.",
  "move.faq.3.q": "Welche Steuern werden beim Kauf gezahlt?",
  "move.faq.3.a": "Für Erstwohnsitz: 2% Registersteuer auf Katasterwert. Für Zweitwohnsitz oder Nicht-Residenten: 9%. Plus feste Hypotheken- und Katastersteuern (je €50).",
  "move.faq.4.q": "Ist ein Notar erforderlich?",
  "move.faq.4.a": "Ja, in Italien ist eine notarielle Urkunde für die Eigentumsübertragung obligatorisch. Der Notar wird vom Käufer gewählt und seine Gebühren trägt der Käufer.",
  "move.faq.5.q": "Kann ich als Ausländer eine Hypothek bekommen?",
  "move.faq.5.a": "Ja, italienische Banken gewähren auch Nicht-Residenten Hypotheken, in der Regel bis zu 60-70% des Immobilienwerts.",
  "move.cta.title": "Bereit für den großen Schritt?",
  "move.cta.text": "Kontaktieren Sie uns für eine kostenlose Beratung. Wir begleiten Sie durch jeden Schritt des Prozesses, in Ihrer Sprache.",
  "move.cta.btn": "Ihre Reise beginnen",

  // Guida acquisto
  "guida.overline": "Vollständiger Leitfaden",
  "guida.title": "Ein Haus in den Marken kaufen:\nder vollständige Leitfaden.",
  "guida.intro": "Von der Immobiliensuche bis zur Urkundenunterzeichnung: alles, was Sie wissen müssen, um ein Haus in den Marken-Dörfern zu kaufen, Schritt für Schritt.",
  "guida.step": "Schritt",
  "guida.step1.title": "Immobiliensuche",
  "guida.step1.text": "Die Suche beginnt mit der klaren Definition Ihrer Bedürfnisse: Immobilientyp, geografische Lage, Budget, Verwendungszweck. In den Marken ist es wichtig, die Dörfer persönlich zu besuchen.",
  "guida.step2.title": "Besichtigung & Bewertung",
  "guida.step2.text": "Die Besichtigung ist der wichtigste Moment. Neben der Immobilie bewerten wir das Dorf, die Dienstleistungen, die lokale Gemeinschaft und die Infrastruktur.",
  "guida.step3.title": "Kaufangebot",
  "guida.step3.text": "Sobald Sie die richtige Immobilie gefunden haben, wird ein schriftliches Kaufangebot mit Anzahlung eingereicht (in der Regel 5-10% des Preises).",
  "guida.step4.title": "Notarielle Urkunde",
  "guida.step4.text": "Die Urkunde ist der endgültige Kaufakt, der vor einem Notar unterzeichnet wird. Der Notar überprüft die Regularität der Immobilie und registriert die Eigentumsübertragung.",
  "guida.step5.title": "Schlüsselübergabe",
  "guida.step5.text": "Nach der Unterzeichnung der Urkunde werden die Schlüssel übergeben und die Immobilie gehört offiziell Ihnen. Es folgen die Versorgungsumschreibungen.",
  "guida.sidebar.cta.title": "Brauchen Sie Hilfe?",
  "guida.sidebar.cta.text": "Wir begleiten Sie durch jeden Schritt des Kaufprozesses.",
  "guida.sidebar.cta.btn": "Kontakt aufnehmen",
  "guida.sidebar.move.text": "Sind Sie Ausländer und möchten in den Marken kaufen? Lesen Sie unseren speziellen Leitfaden.",
  "guida.sidebar.move.btn": "Move to Marche",
  "guida.indice": "Inhaltsverzeichnis",

  // Progetto Modal
  "progetto.title": "Das Projekt",

  // Partner page
  "partner.hero.overline": "UNSER NETZWERK",
  "partner.hero.title": "Partner-Profis",
  "partner.intro": "Ein Haus in Italien zu kaufen, vor allem wenn man aus einem anderen Land kommt, bedeutet, sich auf Menschen zu verlassen, die das Gebiet, die Regeln und die technischen Details wirklich kennen. Deshalb arbeitet Discovering Marche Seite an Seite mit sorgfältig ausgewählten Fachleuten, die Transparenz in jeder Phase der Verhandlung und Qualität in jeder Phase der Umsetzung garantieren.",
  "partner.partner1.overline": "Rechtsanwalts- und Notarkanzlei",
  "partner.partner1.title": "Studio Spanò & Marchionni — Rechtsanwalt & Notar, Fermo",
  "partner.partner1.desc": "Studio Spanò & Marchionni aus Fermo unterstützt Discovering Marche bei den rechtlichen und notariellen Aspekten jeder Immobilienverhandlung. Zwei Schlüsselfiguren — der Rechtsanwalt und der Notar — garantieren die vollständige Transparenz des Vorgangs: Dokumentenprüfung, Schutz aller Parteien, Begleitung durch alle rechtlichen Schritte bis zur notariellen Beurkundung. Eine unverzichtbare Unterstützung, insbesondere für internationale Kunden, die den italienischen Kaufprozess oft nicht kennen.",
  "partner.partner1.bullet1": "Überprüfung der Kataster- und städtebaulichen Konformität",
  "partner.partner1.bullet2": "Unterstützung in jeder Verhandlungsphase, vom Angebot bis zur Urkunde",
  "partner.partner1.bullet3": "Maximale Transparenz für italienische und internationale Käufer",
  "partner.partner2.overline": "Bauunternehmen",
  "partner.partner2.title": "Sparviero Srl — Bauunternehmen, Camerano (AN)",
  "partner.partner2.details": "Unternehmen aktiv seit 2000, ISO 9001 zertifiziert, SOA RINA Kat. OG1 - Klasse III Qualifikation. Umfangreiche Erfahrung in ökologischem Bauen, Komplettsanierungen, Restaurierung historischer Gebäude, Einfamilienhäuser sowie zivilem und industriellem Bau.",
  "partner.partner2.desc": "Sparviero Srl ist das Bauunternehmen, das die Ausführungsqualität der von Discovering Marche betreuten Projekte garantiert. Es hat Eingriffe auf höchstem Niveau in Beherbergungsbetrieben realisiert — darunter Numana Blu S.P.A. in Marcelli — und hat an hochwertigen Wohnanlagen mitgewirkt, die auf Energieeffizienz und ökologische Nachhaltigkeit ausgerichtet sind.",
  "partner.partner2.bullet1": "Komplettsanierungen von Rustici, Bauernhäusern und historischen Gebäuden",
  "partner.partner2.bullet2": "Neubauten und schlüsselfertige Einfamilienhäuser",
  "partner.partner2.bullet3": "Ökologisches Bauen, Energieeffizienz und nachhaltige Materialien",
  "partner.trust.overline": "Warum ein Partnernetzwerk",
  "partner.trust.title": "Die Stärke eines eingespielten Teams.",
  "partner.trust.trasparenza.title": "Transparenz",
  "partner.trust.trasparenza.desc": "Keine rechtlichen oder bürokratischen Überraschungen: jeder Schritt wird geprüft und geteilt.",
  "partner.trust.qualita.title": "Bauqualität",
  "partner.trust.qualita.desc": "Zertifizierte und überprüfbare Eingriffe mit handwerklichen Exzellenzstandards.",
  "partner.trust.referente.title": "Ein einziger Ansprechpartner",
  "partner.trust.referente.desc": "Discovering Marche koordiniert alle Fachleute für Sie, ohne verwirrende Delegation.",
  "partner.trust.multilingua.title": "Mehrsprachige Unterstützung",
  "partner.trust.multilingua.desc": "Das Team betreut internationale Kunden auf Italienisch, Englisch und Spanisch.",
  "partner.cta.title": "Möchten Sie wissen, wie wir mit unseren Partnern an Ihrem Projekt arbeiten?",
  "partner.cta.text": "Erzählen Sie uns von Ihrem Projekt und wir erklären Ihnen, wie unser Netzwerk von Fachleuten Sie in jeder Phase begleiten kann.",
  "partner.cta.btn": "Erzählen Sie uns von Ihrem Projekt",

  "progetto.sintesi.title": "Projektzusammenfassung",
  "progetto.sintesi.text": "Das Projekt Marche Casa entstand im Rahmen des Regionalprogramms FSE+ 2021-2027 der Region Marken, mit dem Ziel, die Arbeitseingliederung und Selbstständigkeit in wirtschaftlich hochpotenten Sektoren zu fördern, darunter der Immobilienmarkt und der Erlebnistourismus in historischen Dörfern.",
  "progetto.obiettivi.title": "Ziele",
  "progetto.obiettivi.text": "Förderung des Zugangs zur Selbstständigkeit in strategischen Sektoren für die Region Marken. Aufwertung des historischen und ländlichen Immobilienerbes als Hebel für nachhaltige wirtschaftliche Entwicklung. Förderung der Integration zwischen Tourismus, Kultur und Immobilienmarkt in den Innen- und Küstengebieten der Region.",
  "progetto.risultati.title": "Erwartete Ergebnisse",
  "progetto.risultati.text": "Gründung eines Einzelunternehmens im Immobiliensektor, spezialisiert auf historische Dörfer der Marken. Entwicklung eines mehrsprachigen Dienstes zur Gewinnung nationaler und internationaler Käufer. Beitrag zur Wiederbelebung der Marken-Dörfer durch qualifizierte Immobilienvermittlung.",
  "progetto.close": "Schließen",
};

export default de;
